<template>
    <div class="form-group setting">
        <slot name="title">
            <label class="control-label" v-if="title">{{ title }}</label>
        </slot>

        <slot name="description">
            <p class="help-block text-muted" v-if="description">{{ description }}</p>
        </slot>

        <div class="row">
            <div class="col-xs-12">
                <slot></slot>
            </div>
        </div>

        <slot name="description-bottom">
            <p class="help-block text-muted m-b-0" v-if="descriptionBottom">{{ descriptionBottom }}</p>
        </slot>
    </div>
</template>

<script>
export default {
    name: 'Setting',

    props: {
        title: {
            required: false,
            default: null
        },

        description: {
            required: false,
            default: null,
        },

        descriptionBottom: {
            required: false,
            default: null,
        },
    }
}
</script>
